import { createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

import reducer from './reducer';

const middlewares = [ thunk ];

const loggerEnabled = process.env.REACT_APP_REDUX_LOGGER_ENABLED;
if (loggerEnabled && loggerEnabled.toLowerCase() === 'true') {
    const { createLogger } = require(`redux-logger`);
    const logger = createLogger({
        // predicate: (getState, action) => action.type.match(/geofence/i)
    });
    middlewares.push(logger);
}

export default () => {
    const store = createStore(reducer, applyMiddleware(...middlewares))
    const persistor = persistStore(store)
    return { store, persistor }
}
